module.exports = __webpack_public_path__ + "img/menunggu-verifikasi.66f6a33b.png";